export default __webpack_public_path__ + "bf1225a3ca9246e4ed79af514d266a50.png";